var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgButtonLeftBorderreact = function SvgButtonLeftBorderreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.88 107",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "#fff",
    strokeWidth: 2,
    d: "M30.88 1H1.05v17.93h2.31a7.88 7.88 0 0 1 5.25 1.44 8.1 8.1 0 0 1 2.44 4.45 61.41 61.41 0 0 1 .37 9c0 4.9 2.45 8.74 3.45 11.55A12.79 12.79 0 0 0 18 50.61l.17.15a3.94 3.94 0 0 1 .3 5.56l-.37.37-.49.45a14.6 14.6 0 0 0-3 5.55c-.84 2.49-3.17 6.47-3.17 11.94a37.87 37.87 0 0 1-.76 9.62A5.23 5.23 0 0 1 8 87.4c-1.18.62-3.51.93-7 .95V106h29.88"
  })));
};

export default SvgButtonLeftBorderreact;